// @flow
import styled from 'styled-components';

import { colors } from 'bench-style-constants';

const TransactionSidebarBorderedSection = styled.section`
  border-top: 1px solid ${colors.sand};
  ${({ withPadding }) => withPadding && 'padding: 24px;'};
  ${({ alwaysShowDivider }) =>
    alwaysShowDivider
      ? ''
      : `
      &:first-of-type {
        padding-top: 0;
        border-top: none;
      }
    `};
`;

export default TransactionSidebarBorderedSection;
